const PayPrograms = {
  Free: 'Free',
  Plus: 'Plus',
  Premium: 'Premium',
};

export default PayPrograms;
